<ng-container *ngIf="!invitado;else ingresar">
  <div class="media profile-media" (click)="toggleNotificationMobile()">
    <img class="b-r-10" src="assets/images/dashboard/profile.jpg" alt="" />
    <div class="media-body">
      <span>{{ admin ? usuario.nombre : usuario.usuario }}</span>
      <p class="mb-0 font-roboto">
        <ng-container *ngIf="admin">Admin </ng-container>
         
        <i class="middle fa fa-angle-down"></i>
      </p>
    </div>
  </div>
  <ul class="profile-dropdown onhover-show-div" [class.active]="openNotification" style="min-width: 180px !important;">
    <ng-container *ngIf="!admin">
      <!-- MC CATFER-92 -->
      <li class="font-weight-bold nombre-cliente-menu">
        {{ nombreCliente }}
      </li>
    <li>
      <a [routerLink]="['/cuenta-usuario/cuenta']"
        ><app-feather-icons [icon]="'user'"></app-feather-icons
        ><span>{{ "User" | translate }} </span></a
      >
    </li>

    <!-- SC CATFER-8 Se comenta funcionalidad no requerida para ferretti -->
    <!-- <li *ngIf="rol == 1">
      <a [routerLink]="['/gestion-usuarios']"
        ><app-feather-icons [icon]="'users'"></app-feather-icons
        ><span>{{ "Gestión de Usuarios" }} </span></a
      >
    </li>

    <li *ngIf="rol == 1">
      <a [routerLink]="['/config-cliente']"
        ><app-feather-icons [icon]="'settings'"></app-feather-icons
        ><span>{{ "Settings" | translate }} </span></a
      >
    </li> -->
  
    <li>
      <a [href]="exitPage" (click)="logout()"
        ><app-feather-icons [icon]="'log-out'"></app-feather-icons
        ><span>{{ "Log out" | translate }}</span></a
      >
    </li>
  </ng-container>
    <ng-container *ngIf="admin">
      <li>
        <a [href]="exitPage" (click)="logoutAdmin()"
          ><app-feather-icons [icon]="'log-out'"></app-feather-icons
          ><span>{{ "Log out" | translate }} </span></a
        >
      </li>
    </ng-container>
  </ul>
</ng-container>
<ng-template #ingresar>
  <a [routerLink]="['/authentication/logout']"
  ><app-feather-icons [icon]="'user'"></app-feather-icons
  ><span> {{ "Log in" | translate }}</span></a
>
</ng-template>

